import { alpha, Card, CardContent, Chip, Grid, Stack, Typography, useTheme } from '@mui/material';
import { fNumber, getCurrencySymbol } from '@zeta-core';

interface ISummaryItem {
  title: string;
  value: number;
}

const TotalAssetsCard = ({ summary }: { summary: ISummaryItem }) => {
  const theme = useTheme();
  return (
    <Grid container spacing={2} mt={1} marginBottom={1}>
      <Grid
        key={summary.title}
        size={{
          lg: 12,
          md: 12,
          sm: 12
        }}>
        <Card
          sx={{
            background: alpha(theme.palette.background.neutral, 1),
            boxShadow: 'none',
            borderRadius: '12px',
            border: `1px solid ${theme.palette.grey[200]}`,
          }}
        >
          <CardContent
            component={Stack}
            gap={2}
            flexDirection="row"
            justifyContent="space-between"
            sx={{ p: 2, pb: '8px !important', pt: '8px !important' }}
            alignItems="center"
          >
            <Typography variant="subtitle1" id={summary.title}>{summary.title}</Typography>
            <Chip
              id="gbp-value"
              label={getCurrencySymbol('GBP') + fNumber(summary.value)}
              sx={{ fontWeight: 'bolder' }}
              variant="soft"
              color={summary.value >= 0 ? 'success' : 'error'}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default TotalAssetsCard;
